import { useState } from 'react';
import BrandStoryModal from './BrandStoryModal';

const partners = [
  {
    id: 1,
    image: 'https://static.vecteezy.com/system/resources/previews/015/734/092/non_2x/rider-delivery-online-motorcycle-taxi-delivery-food-burger-to-customer-order-through-application-free-png.png',
    title: 'Become a rider',
    description: 'Experience true freedom, flexible hours, and great earnings when you deliver with Sweetplate.',
    cta: 'Install Apk',
    href: 'https://sweetplate.org/sweetplateDriver.apk',
  },
  {
    id: 2,
    image: 'https://i.ibb.co/9HtSdG5V/vendor.png',
    title: 'Become a Vendor',
    description: 'Register your restaurant, culinary arts and stores to start taking orders from sweet clients.',
    cta: 'Start Now',
    href: 'https://merchant.sweetplate.org/',
  },
  
  {
    id: 3,
    image: 'https://play-lh.googleusercontent.com/deq80Ux__qeR_Q9GI2HNtCtoYBUTSOaLW0oMeyD9Y96O0GPV7G_DH22LQ9h_0uj1uV4',
    title: 'Sweetplate Token',
    description: "Looking for your next big opportunity? If you're driven, down-to-earth, and love teamwork, we'd love to have you!",
    cta: 'Learn More',
    href: null,
  },
];

export default function Corporate() {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      {/* Logo divider */}
      <section className="bg-[#F0FBF8] py-10 md:py-12 flex flex-col items-center gap-3">
        <img
          src="https://i.ibb.co/G4Wc9Knk/sweetplate-logo.png"
          alt="Sweet Plate"
          className="h-12 md:h-16 w-auto object-contain"
        />
        <p className="text-gray-500 text-sm font-medium">Let&apos;s do it together</p>
      </section>

      <section id="partners" className="bg-white py-14 md:py-20 px-4 sm:px-6">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-2xl md:text-4xl font-extrabold text-gray-900 text-center mb-10 md:mb-14">
            Let&apos;s do it together
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8">
            {partners.map((p) => (
              <div
                key={p.id}
                className="flex flex-col items-center text-center bg-gray-50 rounded-2xl p-4 md:p-6 hover:bg-[#F0FBF8] transition-colors"
              >
                <div className="w-24 h-24 md:w-40 md:h-40 flex items-center justify-center mb-3 md:mb-4">
                  <img
                    src={p.image}
                    alt={p.title}
                    className="w-full h-full object-contain"
                  />
                </div>
                <h3 className="text-sm md:text-base font-bold text-gray-900 mb-1.5 md:mb-2">{p.title}</h3>
                <p className="text-xs text-gray-500 leading-relaxed mb-4 flex-1">{p.description}</p>
                {p.href ? (
                  <a
                    href={p.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-[#009E81] text-white text-xs md:text-sm font-semibold px-4 md:px-6 py-2 md:py-2.5 rounded-full hover:bg-[#008570] transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {p.cta}
                  </a>
                ) : (
                  <button
                    onClick={() => setModalOpen(true)}
                    className="bg-[#009E81] text-white text-xs md:text-sm font-semibold px-4 md:px-6 py-2 md:py-2.5 rounded-full hover:bg-[#008570] transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {p.cta}
                  </button>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      <BrandStoryModal isOpen={modalOpen} onClose={() => setModalOpen(false)} />
    </>
  );
}
